import ChatContent from './chat/ChatContent';
import AuthChatInput from '../../components/shared/chat-input/AuthChatInput';

const AiAuthContainer = () => {
	return (
		<div className='mt-auto mb-5 max-w-full w-[504px]'>
			<h2 className='text-2xl md:text-5xl mb-2'>Let’s <b>sign</b> in or <b>sign up</b></h2>
			<div className='my-5 flex flex-col'>
				<div className='w-full bg-primary-default rounded-t-2xl py-2 px-5 flex flex-wrap items-center text-white'>
					<img alt='avatar' className='mr-2' src='/svg/auth/avatar.svg' />
					Sofia
				</div>
				<ChatContent />
				<div className='p-5 bg-[#F7F1DA]'>
					<AuthChatInput />
				</div>
			</div>
		</div>
	)
}

export default AiAuthContainer;